import React from 'react';
import {ErrorMessage} from 'formik';
import DatePicker, {registerLocale} from 'react-datepicker';
import {useTranslation} from 'react-i18next';
import nl from 'date-fns/locale/nl';
import en from 'date-fns/locale/en-GB';
registerLocale('nl', nl);
registerLocale('en-US', en);
// We import the en-GB locale to make the time format consitent with the hard coded settings, for which we choose the 24h clock

import 'react-datepicker/dist/react-datepicker.css';
import {DatePickerStructure} from './DatePickerStructure';
import {FormErrorMessage} from '../../../form-features/FormErrorMessage';

function GenericDatePicker(props) {
    const {i18n, t} = useTranslation();

    return (
        <DatePickerStructure
            {...props}
            weekbasis={props.weekPicker}
            label={props.label}
            htmlFor={props.name}
            disabled={props.disabled}
            errorMessage={<ErrorMessage name={props.name} component={FormErrorMessage}></ErrorMessage>}>
            <DatePicker
                locale={i18n.language}
                autoComplete="off"
                id={props.name}
                timeCaption={t('generalShared.time')}
                {...props}
            />
        </DatePickerStructure>
    );
}

export default GenericDatePicker;
